export default (element, data) => {
    if (!element) {
        return;
    }

    element.innerHTML = data;
};
